import { TicketModel } from '@/v2/models/ticketModel';
import { getAdditionalInfoValues } from './reservedAdditionalInfo';

export const VIP_TYPE = 'vip';
export type Vip = {
  color?: string;
  text?: string;
};

const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

/**
 * The Archtics VIP treatment a ticket carries, if any.
 *
 * `color` is expected as `#RGB` or `#RRGGBB` - presto-api owns the swap from the decimal PowerBuilder
 * COLORREF that Archtics stores. Anything else is dropped so the PBS wayfinding colours stand, rather
 * than a raw `7929855` reaching the DOM as an invalid `background-color`.
 */
export function getVip(ticket: TicketModel): Vip {
  const { vipColor, vipText } = getAdditionalInfoValues(ticket, VIP_TYPE);

  return {
    color: vipColor && HEX_COLOR.test(vipColor) ? vipColor : undefined,
    text: vipText,
  };
}
